import React from 'react';
import { Table, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';

const cf = num => numeral(num).format('0,0');
const IMAGE_BASE_URL = 'https://img.dyzio.co/image';
const PostsTable = props => {
  const { posts } = props;
  const latestPost = _.head(posts);
  const earliestPost = _.last(posts);

  const earlyMoment = moment(earliestPost.publishedDate);
  const latestMoment = moment(latestPost.publishedDate);
  const bf = 'YYYY-MM-DD';

  const spanDays = latestMoment.diff(earlyMoment, 'days');
  return (
    <div>
      <h3>This is the POSTS TABLE</h3>
      <h4>We have analysed {posts.length} posts.</h4>
      <p>Spanning {earlyMoment.format(bf)} to {latestMoment.format(bf)} ({spanDays} days)</p>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>post</Table.HeaderCell>
            <Table.HeaderCell>caption</Table.HeaderCell>
            <Table.HeaderCell>mentions</Table.HeaderCell>
            <Table.HeaderCell>hashtags</Table.HeaderCell>
            <Table.HeaderCell>tagged<br />users</Table.HeaderCell>
            <Table.HeaderCell>metrics</Table.HeaderCell>
            <Table.HeaderCell>location</Table.HeaderCell>
            <Table.HeaderCell>Ad?</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>

          {
            _.map(posts, post => (
              <Table.Row>
                <Table.Cell>
                  <div>
                    <img src={`${IMAGE_BASE_URL}/${post.shortcode}/size/t`} alt="post" />
                  </div>
                  <div>
                    <a target="_blank" href={`https://www.instagram.com/p/${post.shortcode}`}>
                      {post.shortcode}
                    </a>
                  </div>
                  <div>{post.instagramHandle}</div>
                  <div>{moment(post.publishedDate).format(bf)}</div>

                </Table.Cell>

                <Table.Cell>
                  {post.text}
                </Table.Cell>
                <Table.Cell>

                  {
                    _.map(post.mentions, m => (
                      <div>{m}</div>
                    ))
                  }
                </Table.Cell>
                <Table.Cell>

                  {
                    _.map(post.hashtags, m => (
                      <div>{m}</div>
                    ))
                  }
                </Table.Cell>
                <Table.Cell>

                  {
                    _.map(post.taggedUsers, m => (
                      <div>{m}</div>
                    ))
                  }
                </Table.Cell>

                <Table.Cell>
                  <div style={{ width: 120 }}>
                    <div><Icon name="heart outline" color="red" />{cf(post.likeCount)}</div>
                    <div><Icon name="comment outline" color="red" />{cf(post.commentCount)}</div>
                    {
                      post.viewCount &&
                      <div>
                        <Icon name="play circle outline" color="red" />{cf(post.viewCount)}
                      </div>
                    }
                  </div>
                </Table.Cell>

                <Table.Cell>{post.location && post.location.slug}</Table.Cell>
                <Table.Cell>{post.isAd && <div>YES</div>}</Table.Cell>
              </Table.Row>

            ))
          }
        </Table.Body>
      </Table>
    </div>
  );
};

export default PostsTable;



// WEBPACK FOOTER //
// ./src/containers/profile/posts-table.js